import { IRootState } from '../../../store'
import { ISceneDescriptionState } from '../store/sceneDescription.types'

export const getSceneDescriptionSelector = (state: IRootState): ISceneDescriptionState => state.sceneDescription
